import {json, MiniSignal, texture} from "p3";
import common from "../../common";
import definitions from "../../definitions";
import GameScene from "../../scenes/GameScene";
import InventoryScene from "../../scenes/InventoryScene";
import settings from "../../settings";
import {iswebfont, locale, resizeLabelToFitText} from "../../utils";

export default class EquipTab extends PIXI.Container {

    constructor() {

        super();

        this._items = [];

        this._itemHolder;

        this._scrolling = false;
        this._scrollPos = 0;
        this._scrollMax = 0;
        this._scrollDistance = 0;

        this._pagePositions = [];
        this._currentPage = 0;

        this.gridWidth = 5;
        this.gridHeight = 4;

        this.signals = {};
        this.signals.itemSelected = new MiniSignal();
    }

    fill(panel)
    {
        const offset = new PIXI.Container();
        this.addChild(offset);

        this._itemHolder = new PIXI.Container();
        offset.addChild(this._itemHolder);

        const boxWidth = 124;
        let boxHeight = 124;

        const slot = common.saveData.activeSlot;

        const itemData = [json("equipment").weapons.slice(), json("equipment").attire.slice()];

        for (let i in itemData) {
            itemData[i].sort((a, b) => {
                return (slot.purchases[b.id] || 0) - (slot.purchases[a.id] || 0);
            })
        }

        const colorMatrix = new PIXI.filters.ColorMatrixFilter();
        colorMatrix.desaturate();

        const areaWidth = panel.width * 0.89;
        const areaHeight = panel.height * 0.9;
        const margin = (areaWidth - (boxWidth * this.gridWidth)) / (this.gridWidth-1); 

        offset.x = -(areaWidth/2);
        offset.y = -(areaHeight/2) + 20;

        let yPos = 0;

        itemData[0].sort((a, b) => {
            return b.amount - a.amount;
        });
        itemData[1].sort((a, b) => {
            return b.amount - a.amount;
        });

        const shopItems = json('shop');

        for (let d in itemData) {

            if(d == 0) {
                boxHeight = boxWidth * 1.25;
            } else {
                boxHeight = boxWidth;
            } 

            let label;
            if (!iswebfont()) {
                label = new PIXI.BitmapText(locale(d == 0 ? "ui_inventory_weapons" : "ui_inventory_clothes").toUpperCase(), {
                    fontName: "Alghera Pro",
                    fontSize: 32,
                    align: "left",
                    tint: 0x9d8d6d
                });
            } else {
                label = new PIXI.Text(locale(d == 0 ? "ui_inventory_weapons" : "ui_inventory_clothes").toUpperCase(), {
                    fontFamily: "FredFredBurger",
                    fontSize: 32,
                    align: "left",
                    fill: 0x9d8d6d
                });
            }
            label.anchor.set(0.5, 0);
            label.x = areaWidth / 2;
            label.y = yPos;
            this._itemHolder.addChild(label);

            let selectionHolder = new PIXI.Container();
            selectionHolder.y = label.y + label.height + margin;
            this._itemHolder.addChild(selectionHolder);

            let currentX = 0;
            let currentY = 0;

            for(let i = 0; i < itemData[d].length; i++){

                if (itemData[d][i].phase > settings.PHASE) {
                    continue;
                }

                let item = new PIXI.NineSlicePlane(texture("inventory_slot"), 30, 30, 30, 30); //new PIXI.Sprite(texture('inventory_slot'));
                item.width = boxWidth;
                item.height = boxHeight;
                this._items.push(item);
                selectionHolder.addChild(item);
                
                item.x = (currentX * boxWidth) + (currentX * margin);
                item.y = (currentY * boxHeight) + (currentY * margin);
                currentX ++;
                if(currentX >= this.gridWidth){
                    currentY ++;
                    currentX = 0;
                }
                item.icon = new PIXI.Sprite(texture(itemData[d][i].thumbnail));
                item.icon.anchor.set(0.5);
                item.icon.x = boxWidth/2;
                item.icon.y = boxHeight/2;
                item.addChild(item.icon);

                if(itemData[d][i].rotation) {
                    item.icon.rotation = itemData[d][i].rotation * PIXI.DEG_TO_RAD;
                }

                let wScale = item.width / item.icon.width;
                let hScale = item.height / item.icon.height;

                item.icon.scale.set(Math.min(wScale, hScale));

                let button = P3.Button.create(
                    PIXI.Texture.BLANK
                );
                item.button = button;
                item.data = itemData[d][i];
                button.width = boxWidth;
                button.height = boxHeight;
                button.x = boxWidth/2;
                button.y = boxHeight/2;
                GameScene.active.signalListeners.push(
                    button.signals.click.add(() => {
                        let buttonText;
                        if (item.equippable) {
                            if (this.getEquippedItem(item.data.type) == item.data.id) {
                                buttonText = "ui_inventory_unequip_item";
                            } else {
                                buttonText = "ui_inventory_equip_item";
                            }
                        } else if (item.shopId) {
                            buttonText = "ui_inventory_go_to_shop";
                        }
                        this.signals.itemSelected.dispatch(item.data, buttonText, item.shopId);
                    }, this)
                );
                item.addChild(button);

                item.tick = new PIXI.Sprite(texture("icon_equiped"));
                item.tick.anchor.set(0.5);
                item.tick.x = item.width/2;
                item.tick.y = item.height-10;
                item.addChild(item.tick);

                let enabled = false;
                if (slot.purchases) {
                    for (let j in shopItems) {
                        for (let k in shopItems[j].metadata) {
                            if (shopItems[j].metadata[k] == itemData[d][i].id) {
                                item.shopId = shopItems[j].id;
                                if (slot.purchases[shopItems[j].id] > 0) {
                                    enabled = true;
                                    item.equippable = true;
                                    break;
                                }
                            }
                        }
                    }
                }
                if (slot.unlocks && slot.unlocks.indexOf(itemData[d][i].id) > -1) {
                    enabled = true;
                    item.equippable = true;
                }
                if (!enabled) {
                    item.icon.filters = [colorMatrix];
                    item.icon.alpha = 0.5;
                }
            }

            this._pagePositions[d] = yPos;

            yPos += label.height + margin + selectionHolder.height + margin;
        }

        this._updateItemsEquippedState();

        this._mask = new PIXI.Sprite(PIXI.Texture.WHITE);
        this.addChild(this._mask);
        this._mask.anchor.set(0.5);
        this._mask.width = areaWidth;
        this._mask.height = areaHeight;
        this._itemHolder.mask = this._mask;
    }

    scroll(direction) {
        if(this._scrolling)
            return;

        if(direction < 0 && this.checkScrollUp()) {
            this._currentPage--;
        } else if(direction > 0 && this.checkScrollDown()) {
            this._currentPage++;
        } else {
            return;
        }

        this._scrolling = true;

        GameScene.active.addTween(gsap.to(this._itemHolder, 0.5, {y:-this._pagePositions[this._currentPage], ease:Expo.easeOut, onComplete:() => {
            this._scrolling = false;
        }}));
    }

    checkScrollUp() {
        return this._currentPage > 0;
    }

    checkScrollDown() {
        return this._currentPage < this._pagePositions.length-1;
    }

    getEquippedItem(type) {
        return common.saveData.activeSlot.player[type];
    }

    setEquippedItem(type, id) {
        const oldHealth = GameScene.active.hud.healthBar.health;
        const hadFullHealth = oldHealth == GameScene.active.hud.healthBar.healthMax;
        
        const totalHealth = this.updateStats(type, id);
        common.saveData.activeSlot.player[type] = id;

        if (type === "weapon") {
            GameScene.active.hud.actionButton.setAction(definitions.PLAYER_ACTION.ATTACK, true, true);
        }

        if (totalHealth != 0) {
            const newHealth = hadFullHealth ? null : Math.min(oldHealth, (common.saveData.activeSlot.player.hearts + totalHealth) * 4);
            GameScene.active.setPlayerHearts(common.saveData.activeSlot.player.hearts + totalHealth, true, newHealth);
            InventoryScene.active.addHealthBar();
            InventoryScene.active.healthBar.setHearts(common.saveData.activeSlot.player.hearts, true);
            if (newHealth != null) {
                InventoryScene.active.healthBar.health = newHealth;
            }
        }

        common.saveData.saveGame();

        InventoryScene.active.setIvandoeSkin();

        this._updateItemsEquippedState();
    }

    unequipItem(type) {
        const oldHealth = GameScene.active.hud.healthBar.health;
        const hadFullHealth = oldHealth == GameScene.active.hud.healthBar.healthMax;

        const totalHealth = this.updateStats(type);
        common.saveData.activeSlot.player[type] = null;
        if (type === "weapon") {
            GameScene.active.hud.actionButton.setAction(definitions.PLAYER_ACTION.ATTACK, true, true);
        }
        if (totalHealth != 0) {
            const newHealth = hadFullHealth ? null : Math.min(oldHealth, (common.saveData.activeSlot.player.hearts + totalHealth) * 4);
            GameScene.active.setPlayerHearts(common.saveData.activeSlot.player.hearts + totalHealth, true, newHealth);
            InventoryScene.active.addHealthBar();
            InventoryScene.active.healthBar.setHearts(common.saveData.activeSlot.player.hearts, true);
            if (newHealth != null) {
                InventoryScene.active.healthBar.health = newHealth;
            }
        }
        common.saveData.saveGame();
        InventoryScene.active.setIvandoeSkin();
        this._updateItemsEquippedState();
    }

    updateStats(type, id) {

        const equipment = json('equipment');
        let totalHealth = 0;

        for (let i in equipment){
            for (let j in equipment[i]) {
                if(equipment[i][j].id == common.saveData.activeSlot.player[type]) {
                    if (equipment[i][j].stats.effect) {
                        delete common.saveData.activeSlot.player.effects[equipment[i][j].stats.effect];
                    }
                }
            }
        }
        for (let j in equipment) {
            for (let k in equipment[j]) {
                if (equipment[j][k].id == id && equipment[j][k].stats) {
                    if (equipment[j][k].stats.health) {
                        totalHealth += equipment[j][k].stats.health;
                    }
                    if (equipment[j][k].stats.range) {
                        GameScene.active.player.setAttackRange(equipment[j][k].stats.range);
                    }
                    if (equipment[j][k].stats.power) {
                        GameScene.active.player.setAttackPower(equipment[j][k].stats.power);
                    }
                    if (equipment[j][k].stats.effect) {
                        common.saveData.activeSlot.player.effects[equipment[j][k].stats.effect] = true;
                    }
                }
                if (equipment[j][k].id == common.saveData.activeSlot.player[type] && equipment[j][k].stats) {
                    if (equipment[j][k].stats.health) {
                        totalHealth -= equipment[j][k].stats.health;
                    }
                }
            }
        }
        return totalHealth;
    }

    _updateItemsEquippedState() {
        for (let i in this._items) {
            this._items[i].tick.visible = common.saveData.activeSlot.player[this._items[i].data.type] == this._items[i].data.id;
            this._items[i].texture = texture(this._items[i].tick.visible ? 'inventory_slot_equiped' : 'inventory_slot');
        }
    }

    get items() {
        return this._items;
    }

    get areaMask() {
        return this._mask;
    }


}